import { IApplicationState } from '../../types/redux';
import { ILegalCheckInfo } from '../../types/legalCheckInfo';

export const selectLegalCheckInfo = (state: IApplicationState): ILegalCheckInfo => state.legalCheckInfo;
